import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {CLOSE__16, CLOSE__24, CHECK__16, CHECK__24} from '@homeaway/svg-defs';
import classNames from 'classnames';
import './Switch.less';

/**
 * CheckRadioBase
 *
 * This is the base component for RadioButtons and Checkboxes.
 */

class Switch extends Component {
    static propTypes = {
        /** Text label, can also contain other content if you need it. */
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.element
        ]),
        /** Mark the component as checked */
        checked: PropTypes.bool,
        /** id attribute for label */
        id: PropTypes.string.isRequired,
        /** Size variation from Baseline. Currently only one of: 'sm' */
        size: PropTypes.oneOf(['sm']),
        /** Called when the checked property changes */
        onChange: PropTypes.func,
        /** Should on and off state display SVG checkmark and X. */
        useSVG: PropTypes.bool
    };

    static defaultProps = {
        onChange:
        /* istanbul ignore next */
            () => {},
        useSVG: true
    };


    constructor(props) {
        super(props);
    }

    render() {
        const {label, checked, id, size, useSVG, className, onMouseUp, onTouchEnd, ...rest} = this.props;
        const parentClasses = classNames(className, {
            'switch': true,
            [`switch--${size}`]: size,
            'disabled': !!this.props.disabled
        });

        return (
            <div className={parentClasses} role="switch" aria-checked={checked} onTouchEnd={onTouchEnd} onMouseUp={onMouseUp}>
                <input
                    type="checkbox"
                    id={id}
                    onChange={this.props.onChange}
                    checked={checked}
                    {...rest}
                />
                <label htmlFor={id}>
                    {useSVG &&
                        <SVGIcon inline className="switch-checked text-white" markup={size === 'sm' ? CHECK__16 : CHECK__24} />
                    }
                    {useSVG &&
                        <SVGIcon inline className="switch-unchecked text-white" markup={size === 'sm' ? CLOSE__16 : CLOSE__24} />
                    }
                    <div className="switch-toggle"/>
                </label>
                <label htmlFor={id}>{label}</label>
            </div>
        );
    }
}

export default Switch;
